import projectVersionService from '@rd-web-markets/shared/dist/services/claim_project_reports/project_versions.service';
import { Table } from '@rd-web-markets/shared/dist/util';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProjectVersionChanges from './ProjectVersionChanges';
import Pagination from '@rd-web-markets/shared/dist/util/Pagination';
import * as QueryString from 'query-string';
export default function ProjectUpdates(_ref) {
  let {
    report
  } = _ref;
  const [queryParams, setQueryParams] = useState({
    page: 1,
    ...QueryString.parse(location.search)
  });
  const {
    t
  } = useTranslation();
  const [projectVersions, setProjectVersions, fetchProjectVersions, totalPages] = projectVersionService.useFetchAll({
    projectId: report.id,
    initialQueryParams: queryParams
  });
  const [expandedVersions, setExpandedVersions] = useState(new Set());
  if (!report?.id) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const changePageTo = pageNumber => {
    window.scrollTo(0, 0);
    setQueryParams({
      ...queryParams,
      page: pageNumber
    });
  };
  const toggleExpanded = versionId => {
    const newExpanded = new Set(expandedVersions);
    if (newExpanded.has(versionId)) {
      newExpanded.delete(versionId);
    } else {
      newExpanded.add(versionId);
    }
    setExpandedVersions(newExpanded);
  };
  const headers = [{
    text: t('update_type')
  }, {
    text: t('changed_by')
  }, {
    text: t('change_date_time')
  }, {
    text: t('entity_type_change')
  }, {
    text: t('change')
  }, {
    text: t('load_file')
  }];
  const rows = projectVersions.map(version => {
    return {
      key: version.id,
      columns: [version.version_change_type || version.event, version.user_name, createTimezonedDate(new Date(version.created_at), true).toCustomLocaleTimeString(), t(version.event_translation_key, {
        defaultValue: version.event_translation_key
      }), version.is_related_model ? version.summary_detail : /*#__PURE__*/React.createElement(ProjectVersionChanges, {
        version: version,
        isExpanded: expandedVersions.has(version.id),
        toggleExpanded: toggleExpanded
      }), version.attachment_url ? /*#__PURE__*/React.createElement("a", {
        href: version.attachment_url.url
      }, version.attachment_url.filename) : '']
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, Number(queryParams.page), " - ", totalPages), /*#__PURE__*/React.createElement(Table, {
    opts: {
      striped: true,
      className: 'ProjectUpdates-table'
    },
    headers: headers,
    rows: rows,
    showControls: false,
    rowTdStyle: {
      padding: '12px 8px',
      verticalAlign: 'top'
    }
  }), /*#__PURE__*/React.createElement(Pagination, {
    currentPage: Number(queryParams.page),
    totalPages: totalPages,
    handlePageChange: changePageTo
  }));
}